import React, { useState, useEffect } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import axios from "axios";
import DOMPurify from "dompurify";
import aboutBanner from "../assets/images/page-titles/1.webp";

function BlogDetails() {
  const { id } = useParams();
  const navigate = useNavigate();
  const isDevelopment = process.env.NODE_ENV === "development";
  const api_url =
    localStorage.getItem("api_url") || "http://localhost/inscape_backend/api/";
  const [blogData, setBlogData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Get server_url from localStorage
  const server_url = localStorage.getItem("server_url") || "/api/";
  const company_id = localStorage.getItem("company_id") || "1";
  const employee_id = localStorage.getItem("employee_id") || "1";

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    console.log("GELOI", process.env.NODE_ENV);

    if (id) {
      getBlogDetails();
    }
  }, [id]);

  useEffect(() => {
    // Apply background images when component updates
    const applyBackgrounds = () => {
      document.querySelectorAll(".bg-img")?.forEach((el) => {
        const img = el.querySelector("img");
        if (img) {
          const parent = el.parentElement;
          if (parent) {
            parent.style.backgroundImage = `url(${img.src})`;
            parent.style.backgroundSize = "cover";
            parent.style.backgroundPosition = "center";
            parent.classList.add("bg-img");
            if (el.classList.contains("background-size-auto")) {
              parent.classList.add("background-size-auto");
            }
          }
          el.remove();
        }
      });
    };

    // Small delay to ensure DOM is ready
    const timer = setTimeout(applyBackgrounds, 100);
    return () => clearTimeout(timer);
  }, [blogData]);

  const getBlogDetails = async () => {
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("company_id", company_id);
      formData.append("employee_id", employee_id);
      formData.append("type", "2");
      formData.append("blog_id", id);

      const response = await fetch(`${api_url}blog.php`, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (data.status === "1") {
        setBlogData(data.result);
        setError(null);
      } else {
        setError(data.error || "Blog not found");
      }
    } catch (err) {
      console.error("Error fetching blog details:", err);
      setError("Failed to load blog details");
    } finally {
      setLoading(false);
    }
  };

  // Format date
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  // Split tags into array
  const getTags = (tagsString) => {
    if (!tagsString) return [];
    return tagsString.split(",").map((tag) => tag.trim());
  };

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "400px",
          fontSize: "18px",
          color: "#666",
        }}
      >
        Loading...
      </div>
    );
  }

  if (error || !blogData) {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "400px",
          padding: "20px",
        }}
      >
        <h3 style={{ color: "#721c24", marginBottom: "20px" }}>
          {error || "Blog not found"}
        </h3>
        <button
          onClick={() => navigate("/blog")}
          style={{
            padding: "10px 20px",
            backgroundColor: "#ff6600",
            color: "white",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
          }}
        >
          Back to Blogs
        </button>
      </div>
    );
  }

  return (
    <>
      {/* Banner/Breadcrumb Section */}
      <section className="page-title-layout1 page-title-light bg-parallax bg-overlay text-center">
        <div className="bg-img">
          <img src={aboutBanner} alt="background" />
        </div>
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h1 className="pagetitle-heading">{blogData.blog_title}</h1>
              <nav>
                <ol className="breadcrumb justify-content-center mb-0">
                  <li className="breadcrumb-item">
                    <Link to="/">Home</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    {blogData.blog_title}
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </section>

      <section className="blog blog-single pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-12">
              <div className="post-item single-post-item mb-0">
                <div className="post-img">
                  <img
                    src={
                      blogData.blog_image_url ||
                      "assets/images/blog/standard/1.webp"
                    }
                    alt={blogData.blog_title}
                    className="w-100"
                    style={{ objectFit: "cover", maxHeight: "500px" }}
                  />
                </div>
                {/* /.post-img */}
                <div className="post-body">
                  <div className="post-meta d-inline-flex align-items-center bg-white">
                    <div className="post-meta-cat mb-0">
                      {getTags(blogData.blog_tags).map((tag, index) => (
                        <a href="#" key={index}>
                          {tag}
                        </a>
                      ))}
                    </div>
                    {/* /.blog-meta-cat */}
                    <span className="post-meta-date">
                      {formatDate(blogData.c_date)}
                    </span>
                  </div>
                  {/* /.post-meta */}
                  <h1 className="post-title">{blogData.blog_title}</h1>

                  {/* Short Description */}
                  <div className="post-desc">
                    <p>{blogData.blog_short_txt}</p>
                  </div>
                  {/* /.post-desc */}

                  {/* Long Description with HTML */}
                  <div
                    className="post-desc"
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(blogData.blog_long_txt),
                    }}
                  />
                  {/* /.post-desc */}

                  <div className="d-flex flex-column align-items-center border-top pt-30">
                    <div className="widget-tags">
                      <ul className="list-unstyled d-flex flex-wrap mb-20">
                        {getTags(blogData.blog_tags).map((tag, index) => (
                          <li key={index}>
                            <a href="#">{tag}</a>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* /.col-lg-12 */}
          </div>
          {/* /.row */}
        </div>
        {/* /.container */}
      </section>
    </>
  );
}

export default BlogDetails;
